import React from 'react';
import { LocalItem, LocalVariation } from '~Types';
import styled from '@emotion/styled';
import EditItem from './EditItem';
import { CompleteExpressQueryKiosk_company_categories_items } from '~Scenes/SelfServiceKiosks/Components/useExpressQuery/__queries__';

const Wrapper = styled.div<{ visible: boolean; animationDuration: number }>`
  position: absolute;
  top: 0;
  left: ${({ visible }) => (visible ? '0px' : '-100%')};
  bottom: 0;
  transition: left ${({ animationDuration }) => animationDuration}ms;
  background: #fff;
`;

export type Order = {
  item: LocalItem;
  selectedVariations: LocalVariation[];
  removedVariations: LocalVariation[];
  quantity: number;
  price: number;
};
interface Props {
  cartItemsQuantity: number;
  dialogActiveScreen: string;
  showEdit: boolean;
  item: LocalItem | undefined;
  selectedItem: CompleteExpressQueryKiosk_company_categories_items | undefined;
  editItem: LocalItem | null;
  onEditOrder: (
    id: string,
    variations: LocalVariation[],
    removedVariations: LocalVariation[],
  ) => void;
  animationDuration: number;
}
const EditItemWrapper = ({
  cartItemsQuantity,
  dialogActiveScreen,
  selectedItem,
  showEdit,
  item,
  editItem,
  onEditOrder,
  animationDuration,
}: Props) => {
  const showContent = !!(dialogActiveScreen === 'EDIT_ITEM' && selectedItem && editItem && item);
  return (
    <Wrapper visible={showEdit} animationDuration={animationDuration}>
      {showContent && (
        <EditItem
          cartItemsQuantity={cartItemsQuantity}
          item={item}
          editItem={editItem}
          onEditOrder={onEditOrder}
          hideBottomButtons={!showEdit}
        />
      )}
    </Wrapper>
  );
};

export default EditItemWrapper;
